// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23666%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page container (used by Analytics.jsx) */
.anl-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px;
}

/* Default card shell */
.anl-section {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow);
  padding: 16px;
}

/* Settings container: no fill, no outline */
.anl-section.anl-settings {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;        /* remove default padding */
  margin-top: 0;     /* no top spacing */
}

/* ---------- FIXED 4-ROW SETTINGS LAYOUT ---------- */
:root {
  --control-h: 40px;
}

.anl-row {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
  align-items: center;
  min-height: calc(var(--control-h) + 4px);
  margin: 1px 0;
}

.anl-col { min-width: 0; }
.anl-col.span-12 { grid-column: span 12; }
.anl-col.span-8  { grid-column: span 8; }
.anl-col.span-4  { grid-column: span 4; }

/* Tighter label → input spacing for ALL fields */
.anl-inline {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr); /* was 150px */
  align-items: center;
  gap: 6px;                                     /* was 12px */
}

.anl-label {
  color: var(--blue-main);
  font-weight: 600;
  font-size: 18px;
  white-space: nowrap;
}

/* Inputs/selects fill their slot exactly (Threshold = Country width) */
.anl-inline .anl-input {
  width: 100% !important;
  flex: 1 1 auto;
  box-sizing: border-box;
}

.anl-input {
  height: var(--control-h);
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #f3f5f7;
  padding: 0 10px;
  font-size: 18px;
  color: #1e293b;
  outline: none;
}
.anl-input:focus {
  border-color: #c6d3e1;
  box-shadow: 0 0 0 2px rgba(27, 93, 155, 0.1);
}

/* ---------- Text overflow ellipsis for select dropdowns ---------- */
select.anl-input {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 30px; /* Space for dropdown arrow */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
}

/* Ensure option text also truncates where supported */
select.anl-input option {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

/* Type of Analysis: larger + uppercase; bold when selected */
.anl-type-select { font-size: 20px; font-weight: 500; text-transform: uppercase; }
.anl-type-select.has-value { font-weight: 700; }

/* ---------- Range as a single control ----------
   Apply the SAME tight spacing as other fields */
.anl-range-single {
  grid-template-columns: 100px minmax(0, 1fr); /* was 150px; now matches .anl-inline */
}

/* ---------- CONTENTS AREA ---------- */
.anl-contents-body {
  min-height: 360px;
  height: 600px;
  display: grid;
  place-items: center;
  color: #64748b;
  font-size: 15px;
}

/* Accessibility helper */
.sr-only {
  position: absolute !important;
  clip: rect(1px,1px,1px,1px);
  padding: 0 !important;
  border: 0 !important;
  height: 1px !important;
  width: 1px !important;
  overflow: hidden;
  white-space: nowrap;
}

/* ---------- MonthRangePicker (styled to look like anl-input) ---------- */
.mrp { position: relative; width: 100%; }

.mrp-input {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  cursor: pointer;
  height: var(--control-h);
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #f3f5f7;
  color: #1e293b;
  text-align: left;
  font-size: 18px;
  padding: 0 10px;
  outline: none;
}
.mrp-input:hover { background: #eef2f6; }
.mrp-input-ic { color: var(--blue-main); opacity: 0.7; }
.mrp-input-text.placeholder { color: #94a3b8; }

/* Popup panel */
.mrp-pop {
  position: absolute;
  z-index: 1000;
  top: calc(100% + 6px);
  left: 0;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow);
  display: grid;
  grid-template-columns: 1fr 220px; /* boards | right side */
  gap: 12px;
  padding: 12px;
  min-width: 520px;
}

/* Boards (two years) */
.mrp-boards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.mrp-board {
  border-right: 1px solid #f0f2f6;
  padding-right: 12px;
}
.mrp-board:last-child { border-right: 0; padding-right: 0; }
.mrp-board-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.mrp-icon-btn {
  all: unset;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px; height: 28px;
  border-radius: 6px;
  cursor: pointer;
}
.mrp-icon-btn:hover { background:#eef2f6; }
.mrp-year { font-weight: 700; color:#0A3760; }

.mrp-months {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.mrp-month {
  height: 34px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
}
.mrp-month:hover { background:#f8fafc; }
.mrp-month.is-inrange { background:#e8f0fb; border-color:#d8e5f7; }
.mrp-month.is-start,
.mrp-month.is-end {
  background:#1B5D9B;
  color:#fff;
  border-color:#1B5D9B;
}

/* Right side (presets + actions) */
.mrp-right {
  display: grid;
  grid-template-rows: 1fr auto;
  gap: 12px;
  min-width: 200px;
}
.mrp-presets { display: grid; gap: 8px; }
.mrp-presets button {
  height: 32px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  padding: 0 10px;
  font-weight: 600;
}
.mrp-presets button:hover { background:#f9fafb; }
.mrp-actions { display: flex; justify-content: flex-end; gap: 8px; }
.mrp-actions .anl-btn-primary { height: 32px; padding:0 12px; }
.mrp-actions .action-btn { height: 32px; }

/* ---------- Buttons (Generate/Download) ---------- */
.anl-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  width: max-content;
  margin-left: auto;
}
.anl-btn-primary {
  background: var(--blue-main);
  color: #fff;
  font-weight: 600;
  height: var(--control-h);
  padding: 0 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.anl-btn-primary:hover { background: var(--blue-light); }
/* Square blue button for Download */
.anl-btn-download {
  background: var(--blue-main);
  color: #fff;                   /* icon white */
  width: var(--control-h);        /* square: same as height */
  height: var(--control-h);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;                /* icon size */
}

.anl-btn-download:hover {
  background: var(--blue-light);
}

.action-btn,
.sum-pagination button {
  height: var(--control-h);
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-weight: 600;
  color: #000;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}
.action-btn:hover,
.sum-pagination button:hover {
  background: #f9fafb;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
}

/* ---------- Responsive ---------- */
@media (max-width: 1100px) {
  .anl-col.span-4 { grid-column: span 6; }
  .anl-col.span-8 { grid-column: span 12; }
}
@media (max-width: 720px) {
  .anl-row { grid-template-columns: repeat(6, 1fr); }
  .anl-col.span-4 { grid-column: span 6; }
  .anl-col.span-8 { grid-column: span 6; }
  .anl-col.span-12 { grid-column: span 6; }
  .anl-inline { grid-template-columns: 110px 1fr; }
  .anl-range-single { grid-template-columns: 110px 1fr; }
}

.anl-input:has(option[value=""]:checked) {
  color: #94a3b8;    /* lighter gray, matches Range placeholder */
  font-weight: 400;
}
/* Disabled months: lighter color, no pointer, muted border */
.mrp-month.is-disabled,
.mrp-month:disabled {
color: #cbd5e1;          /* light slate (same family as placeholders) */
border-color: #e5e7eb;
background: #fafafa;
pointer-events: none;
cursor: default;
opacity: 1;              /* keep consistent text color; not faded by opacity */
}

/* Disabled state for primary & download buttons */
.anl-btn-primary:disabled,
.anl-btn-download:disabled {
opacity: 0.5;
cursor: not-allowed;
pointer-events: none;   /* prevents clicks visually & functionally */
}

/* Placeholder color matches dropdown placeholder */
.anl-input::placeholder {
  color: #94a3b8;   /* same as unselected dropdowns */
  opacity: 1;       /* force consistent look across browsers */
}

/* Normal text color when user types */
.anl-input {
  color: #1e293b;   /* same as other selected values */
}

/* Make the page a grid so we control vertical spacing explicitly */
.anl-page {
  display: grid;
  row-gap: 6px;          /* << tighten spacing between sections */
}

/* Ensure sections themselves don't add extra space */
.anl-page > .anl-section {
  margin: 0 !important;
  padding-bottom: 0;
}

.anl-error {
  margin-top: 6px;
  padding: 6px 10px;
  border: 1px solid #ef4444;
  background: #fee2e2;
  color: #991b1b;
  border-radius: 6px;
  font-size: 13px;
}  

/* Analytics Contents – rebuilt with flexible height panels */

:root{
--acnt-text: #334155;      /* slate-700 */
--acnt-sub: #64748b;       /* slate-500 */
--acnt-hint:#94a3b8;       /* slate-400 */
--acnt-border:#e5e7eb;     /* gray-200 */
--acnt-bg: #ffffff;
--acnt-gap: 10px;
}

/* Wrapper */
.acnt {
display: block;
background: var(--acnt-bg);
color: var(--acnt-text);
padding: 8px 0;
}

/* Head */
.acnt__head { margin-bottom: 8px; }
.acnt__head-title { font-weight: 600; font-size: 16px; }
.acnt__head-sub { font-size: 12px; color: var(--acnt-sub); }

/* Empty / Ready */
.acnt__msg { font-size: 16px; color: var(--acnt-sub); text-align: right;}
.acnt__ready { display: flex; flex-direction: column; gap: 6px; padding-left: 800px}
.acnt__title { font-size: 16px; color: var(--acnt-sub); }
.acnt__kv { margin: 0; padding-left: 20px; line-height: 1.45; font-size: 15px; }
.acnt__kv li { margin: 2px 0; }
.acnt__hint { font-size: 14px; color: var(--acnt-hint); }

/* SECTION 2: flexible height layout - chart fixed, table grows naturally */
.acnt__sec2 {
display: flex;
flex-direction: column;
gap: var(--acnt-gap);
}

/* Panel box */
.acnt__panel {
border: 1px solid var(--acnt-border);
border-radius: 8px;
background: #fff;
overflow: hidden;
display: flex;
flex-direction: column;
}

/* Chart panel - fixed height */
.acnt__panel--chart {
height: 300px;  /* Fixed height for chart visibility */
min-height: 300px;
}

/* Table panel - grows naturally, no max height */
.acnt__panel--table {
height: auto;  /* Allow natural height */
min-height: 200px;  /* Minimum for small datasets */
}

/* Panel body fills available space */
.acnt__panel-body {
flex: 1 1 auto;
width: 100%;
display: block;
}

/* Remove internal scrolling - let page scroll handle it */
.acnt__panel-scroll {
overflow: visible;  /* Changed from auto to visible */
}

/* Panel base */
.acnt__panel {
border: 2px solid var(--acnt-border);
border-radius: 8px;
background: #fff;
overflow: visible;  /* Changed from hidden to visible for table */
display: flex;
}

/* Top panel (chart) border color */
.acnt__panel:nth-child(1) {
border-color: transparent;
overflow: hidden;  /* Keep hidden for chart */
}

/* Bottom panel (table) border color */
.acnt__panel:nth-child(2) {
border-color: transparent;
overflow: visible;  /* Allow table to expand */
}

/* Generated timestamp only */
.acnt__generated {
font-size: 16px;
color: var(--acnt-sub);
text-align: right;
margin-bottom: 2px;
}

/* Kill padding at the top of the contents block and shrink the timestamp gap */
.acnt {
padding-top: 0 !important;
margin-top: 0 !important;
}

.acnt__generated {
margin: 2px 0 4px !important;
line-height: 1.2;
text-align: right;
}

/* Make a panel span full height when used alone (4th analysis) */
.acnt__panel--full {
height: 600px;  /* Fixed height for full-screen chart */
min-height: 600px;
}

/* Disabled select styling */
.anl-input:disabled {
background: #e5e7eb;
color: #9ca3af;
cursor: not-allowed;
opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/components/analytics/Analytics.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU,SAAS,2BAA2B;EAC9C,aAAa,MAAM,mBAAmB;AACxC;;AAEA,sDAAsD;AACtD;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA,WAAW,YAAY,EAAE;AACzB,mBAAmB,oBAAoB,EAAE;AACzC,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,mBAAmB,EAAE;;AAExC,iDAAiD;AACjD;EACE,aAAa;EACb,2CAA2C,EAAE,cAAc;EAC3D,mBAAmB;EACnB,QAAQ,sCAAsC,aAAa;AAC7D;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,sEAAsE;AACtE;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB,EAAE,6BAA6B;EAClD,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAAuL;EACvL,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA,sDAAsD;AACtD;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AACjF,6BAA6B,gBAAgB,EAAE;;AAE/C;iDACiD;AACjD;EACE,2CAA2C,EAAE,uCAAuC;AACtF;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E,OAAO,kBAAkB,EAAE,WAAW,EAAE;;AAExC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,eAAe;EACf,wBAAwB;EACxB,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;AACf;AACA,mBAAmB,mBAAmB,EAAE;AACxC,gBAAgB,uBAAuB,EAAE,YAAY,EAAE;AACvD,8BAA8B,cAAc,EAAE;;AAE9C,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,gCAAgC,EAAE,wBAAwB;EAC1D,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA,wBAAwB,eAAe,EAAE,gBAAgB,EAAE;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA,sBAAsB,kBAAkB,EAAE;AAC1C,YAAY,gBAAgB,EAAE,aAAa,EAAE;;AAE7C;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA,mBAAmB,kBAAkB,EAAE;AACvC,wBAAwB,kBAAkB,EAAE,oBAAoB,EAAE;AAClE;;EAEE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;AACA,eAAe,aAAa,EAAE,QAAQ,EAAE;AACxC;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA,4BAA4B,kBAAkB,EAAE;AAChD,eAAe,aAAa,EAAE,yBAAyB,EAAE,QAAQ,EAAE;AACnE,gCAAgC,YAAY,EAAE,cAAc,EAAE;AAC9D,2BAA2B,YAAY,EAAE;;AAEzC,sDAAsD;AACtD;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA,yBAAyB,6BAA6B,EAAE;AACxD,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,WAAW,oBAAoB,eAAe;EAC9C,uBAAuB,SAAS,2BAA2B;EAC3D,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,iBAAiB,cAAc;AAChD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sDAAsD;AACxD;AACA;;EAEE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB,mBAAmB,EAAE;EACvC,kBAAkB,oBAAoB,EAAE;AAC1C;AACA;EACE,WAAW,qCAAqC,EAAE;EAClD,kBAAkB,mBAAmB,EAAE;EACvC,kBAAkB,mBAAmB,EAAE;EACvC,mBAAmB,mBAAmB,EAAE;EACxC,cAAc,gCAAgC,EAAE;EAChD,oBAAoB,gCAAgC,EAAE;AACxD;;AAEA;EACE,cAAc,KAAK,4CAA4C;EAC/D,gBAAgB;AAClB;AACA,6DAA6D;AAC7D;;AAEA,cAAc,WAAW,8CAA8C;AACvE,qBAAqB;AACrB,mBAAmB;AACnB,oBAAoB;AACpB,eAAe;AACf,UAAU,eAAe,qDAAqD;AAC9E;;AAEA,kDAAkD;AAClD;;AAEA,YAAY;AACZ,mBAAmB;AACnB,oBAAoB,IAAI,4CAA4C;AACpE;;AAEA,mDAAmD;AACnD;EACE,cAAc,IAAI,iCAAiC;EACnD,UAAU,QAAQ,0CAA0C;AAC9D;;AAEA,sCAAsC;AACtC;EACE,cAAc,IAAI,kCAAkC;AACtD;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,YAAY,WAAW,wCAAwC;AACjE;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6DAA6D;;AAE7D;AACA,oBAAoB,OAAO,cAAc;AACzC,mBAAmB,QAAQ,cAAc;AACzC,mBAAmB,QAAQ,cAAc;AACzC,qBAAqB,MAAM,aAAa;AACxC,kBAAkB;AAClB,gBAAgB;AAChB;;AAEA,YAAY;AACZ;AACA,cAAc;AACd,0BAA0B;AAC1B,uBAAuB;AACvB,cAAc;AACd;;AAEA,SAAS;AACT,cAAc,kBAAkB,EAAE;AAClC,oBAAoB,gBAAgB,EAAE,eAAe,EAAE;AACvD,kBAAkB,eAAe,EAAE,sBAAsB,EAAE;;AAE3D,kBAAkB;AAClB,aAAa,eAAe,EAAE,sBAAsB,EAAE,iBAAiB,CAAC;AACxE,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB;AACnF,eAAe,eAAe,EAAE,sBAAsB,EAAE;AACxD,YAAY,SAAS,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC/E,eAAe,aAAa,EAAE;AAC9B,cAAc,eAAe,EAAE,uBAAuB,EAAE;;AAExD,2EAA2E;AAC3E;AACA,aAAa;AACb,sBAAsB;AACtB,oBAAoB;AACpB;;AAEA,cAAc;AACd;AACA,oCAAoC;AACpC,kBAAkB;AAClB,gBAAgB;AAChB,gBAAgB;AAChB,aAAa;AACb,sBAAsB;AACtB;;AAEA,+BAA+B;AAC/B;AACA,aAAa,GAAG,sCAAsC;AACtD,iBAAiB;AACjB;;AAEA,iDAAiD;AACjD;AACA,YAAY,GAAG,yBAAyB;AACxC,iBAAiB,GAAG,+BAA+B;AACnD;;AAEA,qCAAqC;AACrC;AACA,cAAc;AACd,WAAW;AACX,cAAc;AACd;;AAEA,0DAA0D;AAC1D;AACA,iBAAiB,GAAG,iCAAiC;AACrD;;AAEA,eAAe;AACf;AACA,oCAAoC;AACpC,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,GAAG,6CAA6C;AACjE,aAAa;AACb;;AAEA,mCAAmC;AACnC;AACA,yBAAyB;AACzB,gBAAgB,GAAG,0BAA0B;AAC7C;;AAEA,sCAAsC;AACtC;AACA,yBAAyB;AACzB,iBAAiB,GAAG,0BAA0B;AAC9C;;AAEA,6BAA6B;AAC7B;AACA,eAAe;AACf,sBAAsB;AACtB,iBAAiB;AACjB,kBAAkB;AAClB;;AAEA,+EAA+E;AAC/E;AACA,yBAAyB;AACzB,wBAAwB;AACxB;;AAEA;AACA,4BAA4B;AAC5B,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA,iEAAiE;AACjE;AACA,aAAa,GAAG,uCAAuC;AACvD,iBAAiB;AACjB;;AAEA,4BAA4B;AAC5B;AACA,mBAAmB;AACnB,cAAc;AACd,mBAAmB;AACnB,YAAY;AACZ","sourcesContent":["/* Page container (used by Analytics.jsx) */\n.anl-page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 12px;\n}\n\n/* Default card shell */\n.anl-section {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  box-shadow: var(--shadow);\n  padding: 16px;\n}\n\n/* Settings container: no fill, no outline */\n.anl-section.anl-settings {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 0;        /* remove default padding */\n  margin-top: 0;     /* no top spacing */\n}\n\n/* ---------- FIXED 4-ROW SETTINGS LAYOUT ---------- */\n:root {\n  --control-h: 40px;\n}\n\n.anl-row {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 16px;\n  align-items: center;\n  min-height: calc(var(--control-h) + 4px);\n  margin: 1px 0;\n}\n\n.anl-col { min-width: 0; }\n.anl-col.span-12 { grid-column: span 12; }\n.anl-col.span-8  { grid-column: span 8; }\n.anl-col.span-4  { grid-column: span 4; }\n\n/* Tighter label → input spacing for ALL fields */\n.anl-inline {\n  display: grid;\n  grid-template-columns: 100px minmax(0, 1fr); /* was 150px */\n  align-items: center;\n  gap: 6px;                                     /* was 12px */\n}\n\n.anl-label {\n  color: var(--blue-main);\n  font-weight: 600;\n  font-size: 18px;\n  white-space: nowrap;\n}\n\n/* Inputs/selects fill their slot exactly (Threshold = Country width) */\n.anl-inline .anl-input {\n  width: 100% !important;\n  flex: 1 1 auto;\n  box-sizing: border-box;\n}\n\n.anl-input {\n  height: var(--control-h);\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: #f3f5f7;\n  padding: 0 10px;\n  font-size: 18px;\n  color: #1e293b;\n  outline: none;\n}\n.anl-input:focus {\n  border-color: #c6d3e1;\n  box-shadow: 0 0 0 2px rgba(27, 93, 155, 0.1);\n}\n\n/* ---------- Text overflow ellipsis for select dropdowns ---------- */\nselect.anl-input {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-right: 30px; /* Space for dropdown arrow */\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 12px;\n}\n\n/* Ensure option text also truncates where supported */\nselect.anl-input option {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n/* Type of Analysis: larger + uppercase; bold when selected */\n.anl-type-select { font-size: 20px; font-weight: 500; text-transform: uppercase; }\n.anl-type-select.has-value { font-weight: 700; }\n\n/* ---------- Range as a single control ----------\n   Apply the SAME tight spacing as other fields */\n.anl-range-single {\n  grid-template-columns: 100px minmax(0, 1fr); /* was 150px; now matches .anl-inline */\n}\n\n/* ---------- CONTENTS AREA ---------- */\n.anl-contents-body {\n  min-height: 360px;\n  height: 600px;\n  display: grid;\n  place-items: center;\n  color: #64748b;\n  font-size: 15px;\n}\n\n/* Accessibility helper */\n.sr-only {\n  position: absolute !important;\n  clip: rect(1px,1px,1px,1px);\n  padding: 0 !important;\n  border: 0 !important;\n  height: 1px !important;\n  width: 1px !important;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n/* ---------- MonthRangePicker (styled to look like anl-input) ---------- */\n.mrp { position: relative; width: 100%; }\n\n.mrp-input {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  cursor: pointer;\n  height: var(--control-h);\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: #f3f5f7;\n  color: #1e293b;\n  text-align: left;\n  font-size: 18px;\n  padding: 0 10px;\n  outline: none;\n}\n.mrp-input:hover { background: #eef2f6; }\n.mrp-input-ic { color: var(--blue-main); opacity: 0.7; }\n.mrp-input-text.placeholder { color: #94a3b8; }\n\n/* Popup panel */\n.mrp-pop {\n  position: absolute;\n  z-index: 1000;\n  top: calc(100% + 6px);\n  left: 0;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  box-shadow: var(--shadow);\n  display: grid;\n  grid-template-columns: 1fr 220px; /* boards | right side */\n  gap: 12px;\n  padding: 12px;\n  min-width: 520px;\n}\n\n/* Boards (two years) */\n.mrp-boards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n.mrp-board {\n  border-right: 1px solid #f0f2f6;\n  padding-right: 12px;\n}\n.mrp-board:last-child { border-right: 0; padding-right: 0; }\n.mrp-board-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.mrp-icon-btn {\n  all: unset;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px; height: 28px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.mrp-icon-btn:hover { background:#eef2f6; }\n.mrp-year { font-weight: 700; color:#0A3760; }\n\n.mrp-months {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n.mrp-month {\n  height: 34px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 13px;\n}\n.mrp-month:hover { background:#f8fafc; }\n.mrp-month.is-inrange { background:#e8f0fb; border-color:#d8e5f7; }\n.mrp-month.is-start,\n.mrp-month.is-end {\n  background:#1B5D9B;\n  color:#fff;\n  border-color:#1B5D9B;\n}\n\n/* Right side (presets + actions) */\n.mrp-right {\n  display: grid;\n  grid-template-rows: 1fr auto;\n  gap: 12px;\n  min-width: 200px;\n}\n.mrp-presets { display: grid; gap: 8px; }\n.mrp-presets button {\n  height: 32px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  padding: 0 10px;\n  font-weight: 600;\n}\n.mrp-presets button:hover { background:#f9fafb; }\n.mrp-actions { display: flex; justify-content: flex-end; gap: 8px; }\n.mrp-actions .anl-btn-primary { height: 32px; padding:0 12px; }\n.mrp-actions .action-btn { height: 32px; }\n\n/* ---------- Buttons (Generate/Download) ---------- */\n.anl-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  width: max-content;\n  margin-left: auto;\n}\n.anl-btn-primary {\n  background: var(--blue-main);\n  color: #fff;\n  font-weight: 600;\n  height: var(--control-h);\n  padding: 0 14px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.anl-btn-primary:hover { background: var(--blue-light); }\n/* Square blue button for Download */\n.anl-btn-download {\n  background: var(--blue-main);\n  color: #fff;                   /* icon white */\n  width: var(--control-h);        /* square: same as height */\n  height: var(--control-h);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;                /* icon size */\n}\n\n.anl-btn-download:hover {\n  background: var(--blue-light);\n}\n\n.action-btn,\n.sum-pagination button {\n  height: var(--control-h);\n  padding: 0 10px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-weight: 600;\n  color: #000;\n  transition: background 0.2s ease, box-shadow 0.2s ease;\n}\n.action-btn:hover,\n.sum-pagination button:hover {\n  background: #f9fafb;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.06);\n}\n\n/* ---------- Responsive ---------- */\n@media (max-width: 1100px) {\n  .anl-col.span-4 { grid-column: span 6; }\n  .anl-col.span-8 { grid-column: span 12; }\n}\n@media (max-width: 720px) {\n  .anl-row { grid-template-columns: repeat(6, 1fr); }\n  .anl-col.span-4 { grid-column: span 6; }\n  .anl-col.span-8 { grid-column: span 6; }\n  .anl-col.span-12 { grid-column: span 6; }\n  .anl-inline { grid-template-columns: 110px 1fr; }\n  .anl-range-single { grid-template-columns: 110px 1fr; }\n}\n\n.anl-input:has(option[value=\"\"]:checked) {\n  color: #94a3b8;    /* lighter gray, matches Range placeholder */\n  font-weight: 400;\n}\n/* Disabled months: lighter color, no pointer, muted border */\n.mrp-month.is-disabled,\n.mrp-month:disabled {\ncolor: #cbd5e1;          /* light slate (same family as placeholders) */\nborder-color: #e5e7eb;\nbackground: #fafafa;\npointer-events: none;\ncursor: default;\nopacity: 1;              /* keep consistent text color; not faded by opacity */\n}\n\n/* Disabled state for primary & download buttons */\n.anl-btn-primary:disabled,\n.anl-btn-download:disabled {\nopacity: 0.5;\ncursor: not-allowed;\npointer-events: none;   /* prevents clicks visually & functionally */\n}\n\n/* Placeholder color matches dropdown placeholder */\n.anl-input::placeholder {\n  color: #94a3b8;   /* same as unselected dropdowns */\n  opacity: 1;       /* force consistent look across browsers */\n}\n\n/* Normal text color when user types */\n.anl-input {\n  color: #1e293b;   /* same as other selected values */\n}\n\n/* Make the page a grid so we control vertical spacing explicitly */\n.anl-page {\n  display: grid;\n  row-gap: 6px;          /* << tighten spacing between sections */\n}\n\n/* Ensure sections themselves don't add extra space */\n.anl-page > .anl-section {\n  margin: 0 !important;\n  padding-bottom: 0;\n}\n\n.anl-error {\n  margin-top: 6px;\n  padding: 6px 10px;\n  border: 1px solid #ef4444;\n  background: #fee2e2;\n  color: #991b1b;\n  border-radius: 6px;\n  font-size: 13px;\n}  \n\n/* Analytics Contents – rebuilt with flexible height panels */\n\n:root{\n--acnt-text: #334155;      /* slate-700 */\n--acnt-sub: #64748b;       /* slate-500 */\n--acnt-hint:#94a3b8;       /* slate-400 */\n--acnt-border:#e5e7eb;     /* gray-200 */\n--acnt-bg: #ffffff;\n--acnt-gap: 10px;\n}\n\n/* Wrapper */\n.acnt {\ndisplay: block;\nbackground: var(--acnt-bg);\ncolor: var(--acnt-text);\npadding: 8px 0;\n}\n\n/* Head */\n.acnt__head { margin-bottom: 8px; }\n.acnt__head-title { font-weight: 600; font-size: 16px; }\n.acnt__head-sub { font-size: 12px; color: var(--acnt-sub); }\n\n/* Empty / Ready */\n.acnt__msg { font-size: 16px; color: var(--acnt-sub); text-align: right;}\n.acnt__ready { display: flex; flex-direction: column; gap: 6px; padding-left: 800px}\n.acnt__title { font-size: 16px; color: var(--acnt-sub); }\n.acnt__kv { margin: 0; padding-left: 20px; line-height: 1.45; font-size: 15px; }\n.acnt__kv li { margin: 2px 0; }\n.acnt__hint { font-size: 14px; color: var(--acnt-hint); }\n\n/* SECTION 2: flexible height layout - chart fixed, table grows naturally */\n.acnt__sec2 {\ndisplay: flex;\nflex-direction: column;\ngap: var(--acnt-gap);\n}\n\n/* Panel box */\n.acnt__panel {\nborder: 1px solid var(--acnt-border);\nborder-radius: 8px;\nbackground: #fff;\noverflow: hidden;\ndisplay: flex;\nflex-direction: column;\n}\n\n/* Chart panel - fixed height */\n.acnt__panel--chart {\nheight: 300px;  /* Fixed height for chart visibility */\nmin-height: 300px;\n}\n\n/* Table panel - grows naturally, no max height */\n.acnt__panel--table {\nheight: auto;  /* Allow natural height */\nmin-height: 200px;  /* Minimum for small datasets */\n}\n\n/* Panel body fills available space */\n.acnt__panel-body {\nflex: 1 1 auto;\nwidth: 100%;\ndisplay: block;\n}\n\n/* Remove internal scrolling - let page scroll handle it */\n.acnt__panel-scroll {\noverflow: visible;  /* Changed from auto to visible */\n}\n\n/* Panel base */\n.acnt__panel {\nborder: 2px solid var(--acnt-border);\nborder-radius: 8px;\nbackground: #fff;\noverflow: visible;  /* Changed from hidden to visible for table */\ndisplay: flex;\n}\n\n/* Top panel (chart) border color */\n.acnt__panel:nth-child(1) {\nborder-color: transparent;\noverflow: hidden;  /* Keep hidden for chart */\n}\n\n/* Bottom panel (table) border color */\n.acnt__panel:nth-child(2) {\nborder-color: transparent;\noverflow: visible;  /* Allow table to expand */\n}\n\n/* Generated timestamp only */\n.acnt__generated {\nfont-size: 16px;\ncolor: var(--acnt-sub);\ntext-align: right;\nmargin-bottom: 2px;\n}\n\n/* Kill padding at the top of the contents block and shrink the timestamp gap */\n.acnt {\npadding-top: 0 !important;\nmargin-top: 0 !important;\n}\n\n.acnt__generated {\nmargin: 2px 0 4px !important;\nline-height: 1.2;\ntext-align: right;\n}\n\n/* Make a panel span full height when used alone (4th analysis) */\n.acnt__panel--full {\nheight: 600px;  /* Fixed height for full-screen chart */\nmin-height: 600px;\n}\n\n/* Disabled select styling */\n.anl-input:disabled {\nbackground: #e5e7eb;\ncolor: #9ca3af;\ncursor: not-allowed;\nopacity: 0.6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
